(function () {
    'use strict';

    angular
        .module('iMatApp')
        .controller('ModelTabController', ModelTabController);

    ModelTabController.$inject = ['$scope', 'modelTabWorkflow'];

    function ModelTabController($scope, modelTabWorkflow) {

        var vm = this;
        vm.getViewName = getViewName;

        activate();

        // --------------------------------------------------------------------------

        function activate() {
            modelTabWorkflow.init($scope);
        }

        function getViewName() {
            var viewName = modelTabWorkflow.getViewName();
            return viewName;
        }
    }
})();
